import { API_URL, authFetch } from '../components/utils/auth';

async function readJson(response, fallback) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || fallback);
  return data;
}

function query(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  return search.toString() ? `?${search}` : '';
}

export async function fetchWorkboard(params = {}) {
  const response = await authFetch(`${API_URL}/staff/workboard/${query(params)}`);
  return readJson(response, 'Unable to load Workboard.');
}

export async function fetchTeamBoard(teamId, params = {}) {
  const response = await authFetch(`${API_URL}/staff/workboard/teams/${teamId}/${query(params)}`);
  return readJson(response, 'Unable to load team board.');
}

export async function createTicket(teamId, payload) {
  const response = await authFetch(`${API_URL}/staff/workboard/teams/${teamId}/tickets/`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to create ticket.');
}

export async function fetchTicket(ticketId) {
  const response = await authFetch(`${API_URL}/staff/workboard/tickets/${ticketId}/`);
  return readJson(response, 'Unable to load ticket.');
}

export async function updateTicket(ticketId, payload) {
  const response = await authFetch(`${API_URL}/staff/workboard/tickets/${ticketId}/`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to update ticket.');
}

export async function changeTicketStatus(ticketId, status, note = '') {
  const response = await authFetch(`${API_URL}/staff/workboard/tickets/${ticketId}/status/`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status, note }),
  });
  return readJson(response, 'Unable to change status.');
}

export async function assignTicket(ticketId, assigneeId) {
  const response = await authFetch(`${API_URL}/staff/workboard/tickets/${ticketId}/assign/`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ assignee_id: assigneeId || null }),
  });
  return readJson(response, 'Unable to assign ticket.');
}

export async function addNote(ticketId, body) {
  const response = await authFetch(`${API_URL}/staff/workboard/tickets/${ticketId}/notes/`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body }),
  });
  return readJson(response, 'Unable to add note.');
}

export async function addQAReview(ticketId, payload) {
  const response = await authFetch(`${API_URL}/staff/workboard/tickets/${ticketId}/qa/`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to record QA review.');
}

export async function requestCrossTeam(ticketId, payload) {
  const response = await authFetch(`${API_URL}/staff/workboard/tickets/${ticketId}/cross-team/`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to request cross-team work.');
}

export async function uploadAttachment(ticketId, file) {
  const form = new FormData();
  form.append('file', file);
  const response = await authFetch(`${API_URL}/staff/workboard/tickets/${ticketId}/attachments/`, { method: 'POST', body: form });
  return readJson(response, 'Unable to upload attachment.');
}